import { useQuery } from "@tanstack/react-query";
import { getCompletedBundleSessions } from "../services/get-completed-bundle-sessions";

export function useCompletedBundleSessions(bundleUsageId: string | null) {
  return useQuery({
    queryKey: ["completed-bundle-sessions", bundleUsageId],
    queryFn: () => getCompletedBundleSessions(bundleUsageId!),
    enabled: !!bundleUsageId,
    staleTime: 1000 * 60 * 5,
  });
}
